export const normalizeCalculatorInputs = (values = {}) => {
    const hasSecondBattery = Boolean(values.secondBattery);
    const hasBattery = Boolean(values.firstBattery || hasSecondBattery);
    const requestedInverter = String(values.inverterOption || '').toLowerCase();

    return {
        ...values,
        firstBattery: hasBattery,
        secondBattery: hasSecondBattery,
        inverterOption: hasBattery || requestedInverter === 'hybrid'
            ? 'hybrid'
            : (values.inverterOption || 'standard'),
        postcode: String(values.postcode || '').trim().replace(/\s+/g, ' ').toUpperCase(),
    };
};

export const getCalculatorErrorMessage = (error, fallback = 'We cannot complete your calculation. Please try again or contact the installer.') => {
    const data = error?.response?.data;
    if (data?.code === 'PRICING_CONFIGURATION_UNAVAILABLE') {
        return 'We cannot complete your calculation because current calculator settings are unavailable. Please check the property settings and try again.';
    }
    if (typeof error?.friendlyMessage === 'string' && error.friendlyMessage.trim()) return error.friendlyMessage;
    if (typeof data?.message === 'string' && data.message.trim()) return data.message;
    if (typeof data === 'string' && data.trim()) return data;
    return fallback;
};

export const isCompleteCalculationResult = (result) => Boolean(result && typeof result === 'object'
    && !Array.isArray(result) && !result.code && !result.error && result.success !== false && result.isSuccess !== false
    && ['calculatedValue', 'installationCost', 'usedEnergyMCS', 'exportedEnergyMCS', 'usageIncome', 'exportIncome', 'costSaving', 'yearsForPayback']
        .every(key => typeof result[key] === 'number' && Number.isFinite(result[key]) && result[key] >= 0)
    && result.calculationData && ['unitPrice', 'exportPrice', 'co2UK']
        .every(key => typeof result.calculationData[key] === 'number' && Number.isFinite(result.calculationData[key]) && result.calculationData[key] >= 0));

export const readCalculatorBlobText = (blob) => typeof blob.text === 'function' ? blob.text() : new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Could not read the server response'));
    reader.readAsText(blob);
});

export const normalizeCalculatorApiError = async (error) => {
    const data = error?.response?.data;
    if (typeof Blob !== 'undefined' && data instanceof Blob) {
        try {
            const text = await readCalculatorBlobText(data);
            try { error.response.data = JSON.parse(text); } catch { error.response.data = text; }
        } catch {
            error.response.data = null;
        }
    }
    error.friendlyMessage = getCalculatorErrorMessage(error, 'The request could not be completed. Please try again.');
    return error;
};
